import React from 'react';
import { Component } from 'react';
import StartScreen from '../../components/screens/Start/StartScreen';
import AppScreen from '../../components/screens/App/AppScreen';
import DownloadScreen from '../../components/screens/Download/DownloadScreen';
import ContactScreen from '../../components/screens/Contact/ContactScreen';
import LectorScreen from '../../components/screens/Lector/LectorScreen';
import "./HomePage.scss";
import BookScreen from '../../components/screens/Book/BookScreen';
import MoreScreen from '../../components/screens/More/MoreScreen';
import PriceScreen from '../../components/screens/Price/PriceScreen';
import ReviewsScreen from '../../components/screens/Reviews/ReviewsScreen';
import AboutScreen from '../../components/screens/About/AboutScreen';

export default class HomePage extends Component {
    public render() {
        return (
            <div>
                <div className="web-container">

                    <div className="bg-1">
                        <section id="start">
                            <StartScreen />
                        </section>

                        <section id="aplikacja">
                            <AppScreen />
                        </section>
                    </div>

                    <section id="lektor">
                        <LectorScreen />
                    </section>

                    <div className="bg-2">
                        <section id="ksiazka">
                            <BookScreen />
                        </section>

                        <section id="pobierz">
                            <DownloadScreen />
                        </section>

                        <section id="wiecej">
                            <MoreScreen />
                        </section>
                    </div>

                    <section id="cennik">
                        <PriceScreen />
                    </section>

                    <div className="bg-3">
                        <section id="recenzje">
                            <ReviewsScreen />
                        </section>

                        <section id="o-nas">
                            <AboutScreen />
                        </section>

                        <section id="kontakt">
                            <ContactScreen
                                header="Skontaktuj się z nami"
                            />
                        </section>
                    </div>
                </div>
            </div>
        )

    }
}